import { GET } from '..';

// Consulta PÚBLICA (sin token) de la trazabilidad de un certificado de
// circularidad; alimenta la página /trazabilidad/:serial enlazada desde el PDF.
export const getPublicCircularityTraceability = serial =>
	GET(`/api/public/circularity-traceability/${encodeURIComponent(serial)}`);
